import React from "react";
import { useTranslation } from "react-i18next";
import proprietor from "../assets/about/proprietor.png";
import founder from "../assets/about/founder.png";

const About = () => {
  const { t } = useTranslation();
  return (
    <div className="w-10/12 mx-auto p-4">
      <header className="text-center mb-8">
        <h1 className="text-4xl font-bold">{t("brand")}</h1>
        <p className="text-xl text-gray-500">{t("about.since")}</p>
      </header>
      <section className="space-y-8">
        <div className="bg-gray-100 p-6 rounded-lg shadow-lg flex flex-col items-center sm:flex-row sm:space-x-6">
          <img
            src={founder}
            alt="Founder"
            className="w-32 h-32 rounded-full object-cover mb-4 sm:mb-0"
          />
          <div className="text-center sm:text-left">
            <h2 className="text-2xl font-semibold mb-2">
              {t("about.founderName")}
            </h2>
            <p className="text-gray-700 mb-4">
              {t("about.founderBio")}
            </p>
            <p className="font-semibold">{t("about.founderSignature")}</p>
          </div>
        </div>
        <div className="bg-gray-100 p-6 rounded-lg shadow-lg flex flex-col items-center sm:flex-row sm:space-x-6">
          <img
            src={proprietor}
            alt="Director"
            className="w-32 h-32 rounded-full object-cover mb-4 sm:mb-0"
          />
          <div className="text-center sm:text-left">
            <h2 className="text-2xl font-semibold mb-2">
              {t("about.proprietorName")}
            </h2>
            <p className="text-gray-700 mb-4">
              {t("about.proprietorBio")}
            </p>
            <p className="font-semibold">{t("about.proprietorSignature")}</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
